import { paymentSystems } from '../../../mocks/paymentSystems';

export default function PaymentSystemsSection() {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Рейтинг платёжных систем</h2>
          <p className="text-gray-400">Сравнение методов пополнения и вывода средств</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {paymentSystems.map((system, index) => (
            <div 
              key={system.id} 
              className="bg-[#242429] rounded-2xl p-6 hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 animate-on-scroll opacity-0"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-center justify-between mb-4">
                <img src={system.logo} alt={system.name} className="h-12 object-contain" />
                <div className="flex items-center gap-2">
                  <i className="ri-star-fill text-[#d4af37]"></i>
                  <span className="font-bold text-xl">{system.rating}</span>
                </div>
              </div>

              <h3 className="text-2xl font-bold mb-4">{system.name}</h3>

              <div className="space-y-3 mb-6">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Мин. депозит:</span>
                  <span className="font-semibold">{system.minDeposit}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Макс. вывод:</span>
                  <span className="font-semibold">{system.maxWithdrawal}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Время вывода:</span>
                  <span className="font-semibold text-[#2ecc71]">{system.withdrawalTime}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Комиссия:</span>
                  <span className="font-semibold">{system.commission}</span>
                </div>
              </div>

              <div className="mb-4">
                <div className="text-sm font-semibold text-[#2ecc71] mb-2">Преимущества:</div>
                <ul className="space-y-1">
                  {system.pros.map((pro, idx) => (
                    <li key={idx} className="text-sm text-gray-300 flex items-start gap-2">
                      <i className="ri-add-line text-[#2ecc71] mt-0.5"></i>
                      {pro}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <div className="text-sm font-semibold text-[#c41e3a] mb-2">Недостатки:</div>
                <ul className="space-y-1">
                  {system.cons.map((con, idx) => (
                    <li key={idx} className="text-sm text-gray-300 flex items-start gap-2">
                      <i className="ri-subtract-line text-[#c41e3a] mt-0.5"></i>
                      {con}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}